export default __webpack_public_path__ + "static/media/settlements-page.b3c8d69f.png";